<template>
  <div id="contenedor-main-documentos-relacionados">
    <v-skeleton-loader
      v-if="$apollo.loading"
      type="table-heading, table-tbody">
    </v-skeleton-loader>
    <div v-else>
      <!-- ToolBar -->
      <tool-bar
        :estaCargando="mostrarDescargando"
        class="my-3"
        v-on:agregarDocumentoRelacionado="agregarDocumentoRelacionado"
        v-on:buscar="buscar"
        @expotarDocumentos="mixExportarDocumentosPdf(`${datos.clave} - Documentos Relacionados`)">
      </tool-bar>
    <v-card flat>
      <listado
      v-if="getExistenDocumentos"
      :listadoDocumentosRelacionados="getDocumentosRelacionados"
      />
      </v-card>
      <v-dialog
      v-if="mostrarAgregarDocumentoRelacionado"
      v-model="mostrarAgregarDocumentoRelacionado"
      width="1200">
        <agregar-documento-relacionado
          :idReferencia="idReferencia"
          :moduloOrigen="moduloOrigen"
          :datos="datos"
          v-on:cerrar="cerrarVentana"
        />
      </v-dialog>
      <v-dialog
        v-if="esteDocumentoRelacionado"
        v-model="mostrarEditarDocumentoRelacionado"
        width="1200"
      >
        <editar-documento-relacionado
          :documentoRelacionadoEditar="esteDocumentoRelacionado"
          :moduloOrigen="moduloOrigen"
          :datos="datos"
          v-on:cerrar="cerrarVentana"
        />
      </v-dialog>
      <v-dialog
        v-if="esteDocumentoRelacionado"
        v-model="mostrarEliminarDocumetoRelacionado"
        width="500"
      >
        <eliminar-documento-relacionado
          :documentoRelacionadoEliminar="esteDocumentoRelacionado"
          :idReferenciaDocumentoRelacionado="idReferencia"
          v-on:cerrar="cerrarVentana"
        />
      </v-dialog>
      <v-dialog
        v-if="esteDocumentoRelacionado"
        v-model="mostrarVerDocumentoRelacionado"
        width="1200"
        scrollable>
        <v-card>
          <v-card-title class="secondary--text">
            Vista Documento Relacionado
            <v-spacer></v-spacer>
            <v-btn icon @click="cerrarVentana">
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <ver-documento-pdf
            :documentoPdfVer="esteDocumentoRelacionado"
            :moduloOrigen="moduloOrigen"
            v-on:cerrar="cerrarVentana"
          />
          </v-card-text>
          <v-divider class="bkground" />
          <v-card-actions>
            <v-spacer></v-spacer>
            <custom-button
              @click="cerrarVentana"
              tipo="formCancelar"
              label="Cerrar"
              class="mr-3">
            </custom-button>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-if="progresoDescarga"
        v-model="mostrarDescargando"
        width="200"
        persistent>
        <v-card>
          <v-card-title class="secondary--text">
            <v-row justify="center">
              Descargando
            </v-row>
          </v-card-title>
          <v-row class="pa-4" justify="center" align="center">
            <v-progress-circular
              :size="100"
              :width="15"
              :value="progresoDescarga"
              color="blue darken-1"
              dark
              >
              <h3>{{ progresoDescarga }}%</h3>
            </v-progress-circular>
          </v-row>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import DOCUMENTOS_RELACIONADOS from '@/graphql/querys/administracion/documentosrelacionados/documentosRelacionados.gql';
import EditarDocumentoRelacionado from '@/components/administracion/documentosrelacionados/Editar.vue';
import AgregarDocumentoRelacionado from '@/components/administracion/documentosrelacionados/Agregar.vue';
import EliminarDocumentoRelacionado from '@/components/administracion/documentosrelacionados/Eliminar.vue';
import VerDocumentoPdf from '@/components/VistaDocumentoPdf.vue';
import ToolBar from './ToolBar.vue';
import Listado from './listado/Main.vue';
import eventBus from '@/helpers/eventBus';
import CustomButton from '@/components/buttons/Button.vue';
import mixDescargarArchivo from '@/helpers/mixDescargarArchivo';

export default {
  name: 'DocumentosRelacionadosMain',
  mixins: [mixDescargarArchivo],
  props: {
    idReferencia: {
      type: String,
      required: true,
    },
    soloLectura: {
      type: Boolean,
      required: false,
      default: false,
    },
    tipoLista: {
      type: Boolean,
      required: false,
      default: true,
    },
    moduloOrigen: {
      type: String,
      required: true,
    },
    datos: {
      type: Object,
      required: true,
    },
  },
  components: {
    ToolBar,
    Listado,
    AgregarDocumentoRelacionado,
    EditarDocumentoRelacionado,
    EliminarDocumentoRelacionado,
    VerDocumentoPdf,
    CustomButton,
  },
  data() {
    return {
      mostrarAgregarDocumentoRelacionado: false,
      mostrarEditarDocumentoRelacionado: false,
      mostrarEliminarDocumetoRelacionado: false,
      mostrarVerDocumentoRelacionado: false,
      mostrarDescargando: false,
      progresoDescarga: null,
      esteDocumentoRelacionado: null,
      buscarTexto: '',
    };
  },
  apollo: {
    documentosRelacionados: {
      query: DOCUMENTOS_RELACIONADOS,
      variables() {
        return {
          idReferencia: this.idReferencia,
        };
      },
    },
  },
  methods: {
    cerrarVentana() {
      this.mostrarAgregarDocumentoRelacionado = false;
      this.mostrarEditarDocumentoRelacionado = false;
      this.mostrarEliminarDocumetoRelacionado = false;
      this.mostrarVerDocumentoRelacionado = false;
      this.mostrarDescargando = false;
      this.esteDocumentoRelacionado = null;
      this.progresoDescarga = null;
    },
    agregarDocumentoRelacionado() {
      this.mostrarAgregarDocumentoRelacionado = true;
    },
    buscar(buscarTexto) {
      this.buscarTexto = buscarTexto;
    },
  },
  computed: {
    getExistenDocumentos() {
      if (this.documentosRelacionados.length === 0) return false;
      return true;
    },
    getCatalogoExpediente() {
      if (!this.catalogoExpediente) return [];
      return this.catalogoExpediente
        .slice()
        .sort((a, b) => (a.orden - b.orden));
    },
    getDocumentosRelacionados() {
      if (!this.documentosRelacionados) return [];
      return this.documentosRelacionados
        .filter((documentoRelacionado) => {
          if (!this.buscarTexto) return documentoRelacionado;
          const expt = new RegExp(this.buscarTexto, 'gi');
          const descripcion = this.$normalizacionTexto(documentoRelacionado.descripcion);
          const observaciones = this.$normalizacionTexto(documentoRelacionado.observaciones);

          return (
            expt.test(descripcion)
            || expt.test(observaciones)
            || expt.test(documentoRelacionado.descripcion)
            || expt.test(documentoRelacionado.referencia)
          );
        })
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    },
    mostrarToolBar() {
      if (this.soloLectura || this.tipoLista) return false;
      return true;
    },

    getSoloPublicKeys() {
      if (!this.documentosRelacionados) return [];
      return this.documentosRelacionados
        .filter(({ publicKey }) => publicKey !== null)
        .map(({ publicKey }) => publicKey);
    },
  },
  mounted() {
    eventBus.$on('agregar-documento-relacionado', (documentoRelacionado) => {
      this.esteDocumentoRelacionado = documentoRelacionado;
      this.mostrarAgregarDocumentoRelacionado = true;
    });
    eventBus.$on('editar-documento-relacionado', (documentoRelacionado) => {
      this.esteDocumentoRelacionado = documentoRelacionado;
      this.mostrarEditarDocumentoRelacionado = true;
    });
    eventBus.$on('borrar-documento-relacionado', (documentoRelacionado) => {
      this.esteDocumentoRelacionado = documentoRelacionado;
      this.mostrarEliminarDocumetoRelacionado = true;
    });
    eventBus.$on('ver-documento-relacionado', (documentoRelacionado) => {
      this.esteDocumentoRelacionado = documentoRelacionado;
      this.mostrarVerDocumentoRelacionado = true;
    });
  },
};
</script>

<style lang="scss">
</style>
